var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFormatVertical = function SvgFormatVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18V5C7.5 3.89543 8.39543 3 9.5 3H15.5C16.6046 3 17.5 3.89543 17.5 5V18C17.5 19.1046 16.6046 20 15.5 20H9.5C8.39543 20 7.5 19.1046 7.5 18Z",
    stroke: "currentColor",
    strokeWidth: 1.2
  })));
};
export default SvgFormatVertical;